import React from "react";
import { ArrowUpLeft, Check } from "lucide-react";

const CTA = ({ onRegister, onBook }) => {
  return (
    <section id="contact" className="relative py-24 bg-[#241C15] overflow-hidden">
      <div className="absolute inset-0 opacity-20">
        <img
          src="https://alramzre.com/wp-content/uploads/2026/05/Artboard-6%40300x-100-scaled.jpg"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="relative max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <span className="text-[#D9C08A] text-sm font-700">تواصل مع المسوق الحصري</span>
          <h2 className="font-display text-3xl lg:text-5xl font-700 text-white mt-3 leading-snug">
            اختر خطوتك التالية في مسار كورنر
          </h2>
          <p className="text-stone-300 leading-loose mt-5">
            عبر المسوق الحصري «عقارماب» احصل على كل تفاصيل المشروع أو تواصل مباشرة
            مع فريق المبيعات لاختيار الوحدة المناسبة.
          </p>
        </div>

        <div className="space-y-4">
          <button
            onClick={onRegister}
            className="w-full group bg-white/8 hover:bg-white/14 border border-white/15 rounded-2xl p-6 flex items-center gap-5 text-right transition-colors"
          >
            <span className="w-12 h-12 rounded-xl bg-[#BF9A5A] flex items-center justify-center shrink-0">
              <ArrowUpLeft className="text-white" size={22} />
            </span>
            <span>
              <span className="block text-white font-700 text-lg">سجل اهتمامك</span>
              <span className="block text-stone-400 text-sm mt-1">سيتواصل معك فريقنا للتفاصيل والإجابة عن استفساراتك.</span>
            </span>
          </button>

          <button
            onClick={onBook}
            className="w-full group bg-white/8 hover:bg-white/14 border border-white/15 rounded-2xl p-6 flex items-center gap-5 text-right transition-colors"
          >
            <span className="w-12 h-12 rounded-xl bg-[#BF9A5A] flex items-center justify-center shrink-0">
              <Check className="text-white" size={22} />
            </span>
            <span>
              <span className="block text-white font-700 text-lg">احجز الآن</span>
              <span className="block text-stone-400 text-sm mt-1">اختر وحدتك وقم بحجزها مباشرة.</span>
            </span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default CTA;
